$( document ).ready( function () {
  function getAllCookies() {
    let cookies = {};
    document.cookie.split( ";" ).forEach( function ( cookie ) {
      let [ name, value ] = cookie.split( "=" );
      name = name.trim();
      if ( name ) {
        cookies[ name ] = decodeURIComponent( value );
      }
    } );
    return cookies;
  }

  const allCookies = getAllCookies();
  console.log( "All cookies:", allCookies );

  if ( allCookies[ "discount_used" ] ) {
    console.log( "'discount_used' cookie is present." );

    setTimeout( () => {
      //$('.var_opti3').remove();
    }, 100 );
  } else {
    setTimeout( () => {
      //$('.var_opti2').remove();
    }, 100 );
    $( "body" ).addClass( "no_cookie" );
    //  $('.var_opti3 .fixe_var').trigger('click');
    console.log( "'discount_used' cookie is not present." );
  }
// $('.var_opti3 .fixe_var').trigger('click');
  setTimeout( () => {
    var price_sel = $(
      ".product-form__input input[type=radio]:checked+label .top .subs_price b"
    )
      .text()
      .trim();
    var trimmed_price = price_sel.split( "/" )[ 0 ].trim();
    $( "span.change_price" ).text( trimmed_price );
  }, 1000 );

  var discount_prcatge = $( ".disc_prcebtage" ).text();

  var referrer = document.referrer;

  if ( referrer.includes( "/landing-page" ) ) {
    //  alert();
    console.log( "Page referred from /landing-page" );
    var urlParams = new URLSearchParams( window.location.search );

    if ( urlParams.has( "Code" ) ) {
      var codeValue = urlParams.get( "Code" );
      console.log( "Code found:", codeValue );
      var expiryTime = Date.now() + 3600 * 24000;
      localStorage.setItem(
        "discountCode",
        JSON.stringify( {
          code: codeValue,
          expiry: expiryTime,
        } )
      );
    }
  }

  var storedData = localStorage.getItem( "discountCode" );
  if ( storedData ) {
    var { code, expiry } = JSON.parse( storedData );
    if ( Date.now() < expiry ) {
      console.log( "Valid discount code found:", code );
      applyDiscount( "span.price-item.price-item--sale.price-item--last", false );
      applyDiscount( ".subs_price b", true );
      applyDiscount( ".first_price", true );
    } else {
      console.log( "Stored discount code expired. Clearing local storage." );
      localStorage.removeItem( "discountCode" );
    }
  } else {
    console.log( "No valid discount code found in local storage." );
  }

  $( document ).on( "click", 'input[type="radio"][name="sng_var"]', function ( e ) {
    e.preventDefault();
    const currentRadio = $( this );
    const selectedValue = currentRadio.val();

    // Remove "checked" class from other radio buttons and add it to the current one
    $( 'input[type="radio"][name="sng_var"]' )
      .parent( ".single_purch" )
      .removeClass( "checked" );
    currentRadio.parent( ".single_purch" ).addClass( "checked" );

    // Get the price element associated with the selected radio button
    const priceElement = currentRadio
      .parent( ".single_purch" )
      .find( ".first_price" );

    // Update the displayed price
    currentRadio
      .parents( ".swatch_btn" )
      .find( ".top .subs_price b" )
      .text( priceElement.text() );

    setTimeout( () => {
      const priceValue = parseFloat(
        priceElement.text().replace( /[^0-9.-]+/g, "" )
      ); // Extract numeric value
      //setTimeout(() => {
      //if (!isNaN(priceValue)) {
      //	let newPerDay;
      //if (selectedValue === '60 days') {

      //	newPerDay = (priceValue / 60).toFixed(2);
      // alert(newPerDay);
      //} else if (selectedValue === '180 days') {
      newPerDay = ( priceValue / 180 ).toFixed( 2 ).replace( ".", "," ); // Replace `.` with `,`
      //}

      // Update daily price
      //	if (newPerDay) {
      //		currentRadio.parents('.swatch_btn').find('.pri_jar').text(`${newPerDay}/jour`);
      //	}
      //	}
      //}, 800);
      // Update the price in the `.change_price` element
      if ( priceElement.length ) {
        $( ".change_price" ).text( priceElement.text() );
      }
      const selectedValue = $( this ).val() || "";
      console.log( "🔹 Selected Value:", selectedValue );
      updateDailyPricesInSubs( selectedValue );
      // Update quantity input based on the selected value
      const quantityInput = $( "input.quantity__input" );
      const otherRadio = $( 'input[type="radio"].fixe_var:checked' ).val();
      if ( otherRadio === "Abonnement" ) {
        quantityInput.val( 1 );
      } else {
        const quantityMap = {
          "60 days": 2,
          "180 days": 3,
        };
      quantityInput.val( quantityMap[ selectedValue ] || 1 );
      }

      const multi = currentRadio
        .parent( ".single_purch" )
        .find( ".mult_pri" )
        .text();
      currentRadio.parents( ".swatch_btn " ).find( ".uniq_pri s" ).text( multi );
      console.log( multi );
    }, 1200 );
  } );

  var slec_var = $( ".product-form__input input[type=radio]:checked" ).val();
  // alert(slec_var);
  if (
    slec_var == "Offre découverte" ||
    slec_var == "Discovery Offer" ||
    slec_var == "One-time purchase" ||
    slec_var == "Achat unique" ||
    slec_var == "Achat unique" ||
    slec_var == "Eenmalige aankoop"
  ) {
  //  $( ".buy_quantity" ).addClass( "no_quant" );
  } else {
   // $( ".buy_quantity" ).removeClass( "no_quant" );
  }
  setTimeout( function () {
    var btn_price = $( ".change_price" ).text();
    $( ".fixed_pr" ).text( btn_price );
  }, 1500 );
  $( document ).on( "click", ".var_inner", function () {
    const price = $( this ).find( ".subs_price b" ).text() || "";
    const parts = price.split( "/" );
    setTimeout( function () {
      $( ".change_price" ).text( parts[ 0 ] || "" );
      $( ".fixed_pr" ).text( parts[ 0 ] || "" );
      if ( allCookies[ "discount_used" ] ) {
        //$('.var_opti3').remove();
      } else {
        //$('.var_opti2').remove();
      }

      if ( storedData ) {
        console.log( "Applying discount..." );
        applyDiscount( ".subs_price b" );
        applyDiscount( ".first_price" );
      } else {
        console.log( "No discount code available." );
      }

      replaceTextIfUrlContains( "/nl", {
        mois: "maand",
        jours: "dag",
        jour: "dag",
      } );
      replaceTextIfUrlContains( "/en", {
        mois: "month",
        jours: "days",
        jour: "day",
      } );
      replaceTextIfUrlContains( "/it", {
        mois: "mese",
        jours: "giorni",
        jour: "giorno",
      } );

      $( ".fixed_pr" ).text( parts[ 0 ] || "" );
      var slec_var = $( ".product-form__input input[type=radio]:checked" ).val();
      if (
        slec_var == "Offre découverte" ||
        slec_var == "Discovery Offer" ||
        slec_var == "One-time purchase" ||
        slec_var == "Achat unique" ||
        slec_var == "Achat unique" ||
        slec_var == "Eenmalige aankoop"
      ) {
      //  $( ".buy_quantity" ).addClass( "no_quant" );
      } else {
     //   $( ".buy_quantity" ).removeClass( "no_quant" );
      }
    }, 1000 );
  } );

  function applyDiscount( selector ) {
    const discountPercentageElement = $( ".disc_prcebtage" );
    if ( !discountPercentageElement.length ) {
      console.warn( "Discount percentage element not found" );
      return;
    }

    const discountPercentage = parseFloat(
      discountPercentageElement.text().replace( ",", "." ).trim()
    );
    if ( isNaN( discountPercentage ) ) {
      console.warn( "Invalid discount percentage" );
      return;
    }

    $( selector ).each( function () {
      const element = $( this );

      const originalPrice = element.data( "original-price" ) || element.text();
      if ( !element.data( "original-price" ) ) {
        element.data( "original-price", originalPrice );
      }
      const priceMatch = originalPrice.match(
        /([\d,]+(\.\d{2})?)\s*([€$£]?)(.*)/
      );
      if ( priceMatch ) {
        const priceValue = parseFloat( priceMatch[ 1 ].replace( ",", "." ).trim() );
        const currencySymbol = priceMatch[ 3 ] || "";
        const trailingText = priceMatch[ 4 ] || "";

        if ( !isNaN( priceValue ) ) {
          const discountedPrice = ( priceValue * ( 1 - discountPercentage / 100 ) )
            .toFixed( 2 )
            .replace( ".", "," );
          const newPriceText = `${ discountedPrice }${ currencySymbol } ${ trailingText.trim() }`;
          element.text( newPriceText );
        }
      }
    } );
  }

  function updateDailyPricesInSubs( selectedValue ) {
    if ( !selectedValue ) {
      console.warn( "⚠️ selectedValue is undefined or empty!" );
      return;
    }

    selectedValue = selectedValue.toString().trim(); // Ensure it's a string

    $( ".var_opti2 .subs_price" ).each( function () {
      const subsPriceElement = $( this );
      const priceElement = subsPriceElement.find( "b" );
      const dailyPriceElement = subsPriceElement.find( ".pri_jar" );

      if ( !priceElement.length || !dailyPriceElement.length ) {
        console.warn(
          "⚠️ Price or daily price element not found in:",
          subsPriceElement
        );
        return;
      }

      const originalPriceText = priceElement.text().trim();
      const priceMatch = originalPriceText.match(
        /([\d,]+(\.\d{2})?)\s*([€$£]?)/
      );

      if ( priceMatch ) {
        const priceValue = parseFloat( priceMatch[ 1 ].replace( ",", "." ).trim() );
        const currencySymbol = priceMatch[ 3 ] || "";

        if ( !isNaN( priceValue ) ) {
          let days = 30; // Default
          if ( selectedValue.toLowerCase().includes( "60" ) ) {
            days = 60;
            $( ".uniq_pri" ).css( "display", "block" );
          } else if ( selectedValue.toLowerCase().includes( "180" ) ) {
            days = 90;
          } else if ( selectedValue.toLowerCase().includes( "30" ) ) {
            $( ".uniq_pri" ).css( "display", "none" );
          }

          const dailyPrice = ( priceValue / days ).toFixed( 2 ).replace( ".", "," );
          const newPriceText = `${ dailyPrice }${ currencySymbol }/jour`;
          dailyPriceElement.text( newPriceText );

          console.log( `✅ Updated: ${ newPriceText } for ${ selectedValue }` );
        } else {
          console.warn( "⚠️ Invalid price value for:", priceElement );
        }
      } else {
        console.warn( "⚠️ Failed to parse price for:", priceElement );
      }
    } );
  }
  updateDailyPricesInSubs();

  $( ".price-item--sale" ).each( function () {
    const priceElement = $( this );
    const dailyPriceElement = priceElement.next( ".pri_jar" );
    const originalPriceText = priceElement.text().trim();
    const priceMatch = originalPriceText.match( /([\d,]+(\.\d{2})?)\s*([€$£]?)/ );

    if ( priceMatch ) {
      const priceValue = parseFloat( priceMatch[ 1 ].replace( ",", "." ).trim() );
      const currencySymbol = priceMatch[ 3 ] || "";

      if ( !isNaN( priceValue ) ) {
        const dailyPrice = ( priceValue / 30 ).toFixed( 2 ).replace( ".", "," );
        const newPriceText = `${ dailyPrice }${ currencySymbol }/jour`;
        dailyPriceElement.text( newPriceText );
      } else {
        console.warn( "Invalid price value for:", priceElement );
      }
    } else {
      console.warn( "Failed to parse price for:", priceElement );
    }
  } );

  

  $( ".owl-carousel" ).slick( {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  } );
  $( ".collection-slider" ).slick( {
    slidesToShow: 4,
    slidesToScroll: 1,
    centerPadding: "40px",
    arrows: true,
    nextArrow: '<button type="button" class="slick-next">Next</button>',
    prevArrow: '<button type="button" class="slick-prev">Prev</button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "60px",
          autoplay: true,
          autoplaySpeed: 3000,
        },
      },
    ],
  } );

  $( ".cure-slider" ).slick( {
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    vertical: true,
    verticalSwiping: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          vertical: false,
          verticalSwiping: false,
        },
      },
    ],
  } );

  var title = $( ".cstm-title-coll" ).text();
  $( ".your_need_filter p" ).each( function () {
    var text = $( this ).text();
    if ( title === text ) {
      $( this ).addClass( "activee" );
    }
  } );

  /* Mega menu */

  $( "ul.list-menu li" ).click( function ( e ) {
    $( this ).siblings().removeClass( "active" );
    $( this ).parent().siblings().find( "ul.list-menu li" ).removeClass( "active" );
    $( this ).toggleClass( "active" );
  } );

  /* Custom Add to cart for colletion grid */

  const ajaxAddToCartButtons = document.querySelectorAll(
    ".ajax-add-to-cart-btns"
  );
  ajaxAddToCartButtons.forEach( ( button ) => {
    button.addEventListener( "click", function ( e ) {
      e.preventDefault();
      e.stopPropagation();
      const productId = button.getAttribute( "data-product-id" );
      const sellingPlanId = $( "select#selling_plan" ).val();
      if ( !productId ) {
        alert( "Invalid product selected." );
        return;
      }

      const payload = {
        id: productId,
        quantity: 1,
      };

      if ( sellingPlanId ) {
        payload.selling_plan = sellingPlanId;
      }

      fetch( "/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify( payload ),
      } )
        .then( ( response ) => response.json() )
        .then( ( data ) => {
          console.log( "Product added:", data );

          const cartDrawer = document.querySelector( "cart-drawer.drawer" );
          if ( cartDrawer ) {
            $( "div#CartDrawer" ).load( location.href + " div#CartDrawer" );
            $( ".cart-count-bubble span" ).load(
              location.href + " .cart-count-bubble span"
            );
            cartDrawer.classList.add( "active" );
            cartDrawer.classList.remove( "is-empty" );



          } else {
            console.error( "Cart drawer element not found." );
          }

        } )
        .catch( ( error ) => {
          console.error( "Error adding product to cart:", error );
        } );
    } );
  } );

  /* responsive homepage sliders*/

  if ( $( window ).width() <= 769 ) {
    $( ".team_section>.right" ).slick( {
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1.1,
            slidesToScroll: 1,
          },
        },
      ],
    } );
    $( ".testimonial_outer .review_inner" ).slick( {
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "30px",
          },
        },
      ],
    } );
    $( ".mobile_filter" ).slick( {
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    } );
  }

  $( "body.day .prod-slider" ).slick( {
    slidesToShow: 1, // 1 main slide fully visible
    slidesToScroll: 1,
    centerMode: false,
   // centerPadding: "15%", // Adjust this for half-visible slides
   // infinite: true, // Enable looping if needed
  //  focusOnSelect: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024, // Tablets
        settings: {
          slidesToShow: 1,
          centerPadding: "15%",
        },
      },
      {
        breakpoint: 768, // Mobile devices
        settings: {
          slidesToShow: 1,
          centerPadding: "10%",
          centerMode: false
        },
      },
    ],
  } );
    $( "body.Landing .prod-slider" ).slick( {
    slidesToShow: 1.1, // 1 main slide fully visible
    slidesToScroll: 1,
    centerMode: false,
   // centerPadding: "15%", // Adjust this for half-visible slides
   // infinite: true, // Enable looping if needed
  //  focusOnSelect: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024, // Tablets
        settings: {
          slidesToShow: 1,
          centerPadding: "15%",
        },
      },
      {
        breakpoint: 768, // Mobile devices
        settings: {
          slidesToShow: 1,
          centerPadding: "10%",
          centerMode: false
        },
      },
    ],
  } );




  $( '.slick_marquee .multicolumn-list' ).slick( {
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 3,
    centerMode: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1, // Slightly above 0 to avoid jitter
    speed: 3000, // Slower transition speed for smooth effect

    responsive: [
      {
        breakpoint: 1320,
        settings: { slidesToShow: 4, speed: 6000, slidesToScroll: 4 }
      },
      {
        breakpoint: 1080,
        settings: { slidesToShow: 3, slidesToScroll: 3 }
      },
      {
        breakpoint: 680,
        settings: { slidesToShow: 2, slidesToScroll: 2 }
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1, slidesToScroll: 1 ,  speed: 6000,}
      }
    ]
  } );



  /* Footer mobile accord*/

  $( ".footer-block__heading" ).on( "click", function () {
    $( this ).toggleClass( "active" );
    $( ".footer-block__heading" ).not( this ).removeClass( "active" );
    const nextUl = $( this ).next( "ul.footer-block__details-content" );
    nextUl.toggleClass( "active" );
    $( "ul.footer-block__details-content" ).not( nextUl ).removeClass( "active" );
  } );

  // Target the first `.product__accordion.accordion` and update its `details` child
//  $( ".product__accordion.accordion:first details" ).attr( "open", "open" );

  // Update the `summary` child within the first `.product__accordion.accordion`
 // $( ".product__accordion.accordion:first details summary" ).attr(
   // "aria-expanded",
 //   "true"
//  );

  // Fixed button on product page
  const fullHTML = $( "product-form.product-form" ).html();
  if ( fullHTML ) {
    $( ".fixe_btn" ).html( fullHTML );
    console.log( "HTML added to 'fixed_btn'." );
  } else {
    console.log(
      "The element with class 'product-form product-form' was not found."
    );
  }

  $( ".fixe_btn .form .product-form__buttons .product-form__submit" ).click(
    function ( e ) {
      e.preventDefault();
      $(
        ".product__info-container .product-form form .product-form__submit"
      ).trigger( "click" );
    }
  );

  const url = window.location.href;
  const urlSegment = url.split( "/" ).filter( Boolean ).pop();
  let normalizedUrlSegment = urlSegment
    .replace( /-/g, " " )
    .toLowerCase()
    .normalize( "NFD" )
    .replace( /[\u0300-\u036f]/g, "" );

  $( ".filt_text a" ).each( function () {
    const href = $( this ).attr( "href" ) || "";
    const normalizedHref = href
      .replace( /-/g, " " )
      .toLowerCase()
      .normalize( "NFD" )
      .replace( /[\u0300-\u036f]/g, "" );
    if ( normalizedHref.includes( normalizedUrlSegment ) ) {
      console.log( "Match found:", href );
      $( this ).parent( "p" ).addClass( "matched" );
    }
  } );
  $( ".filter-tags-blogs" ).click( function () {
    $( ".link-dropdown__options" ).toggleClass( "active" );
  } );

 function replaceTextIfUrlContains(urlPart, replacements) {
  if (window.location.href.includes(urlPart)) {
    $("body")
      .find("p, span, h1, h2, h3, h4, h5, h6")
      .each(function () {
        let elementText = $(this).html();
        for (const [search, replace] of Object.entries(replacements)) {
          const regex = new RegExp(`\\b${search}\\b`, "g");
          elementText = elementText.replace(regex, replace);
        }
        $(this).html(elementText);
      });
  }
}

replaceTextIfUrlContains("/nl", {
  mois: "maand",
  jours: "dag",
  jour: "dag",
});

replaceTextIfUrlContains("/en", {
  mois: "month",
  jours: "days",
  jour: "day",
});

replaceTextIfUrlContains("/it", {
  mois: "mese",
  jours: "giorni",
  jour: "giorno",
});

  $( ".variant-opti_sli" ).each( function () {
    const $firstRadio = $( this ).find( "label:first-child input[type='radio']" );
    $firstRadio.prop( "checked", true );
    const radioValue = $firstRadio.val();
    $( this ).prev( "input[name='id']" ).val( radioValue );
    const priceText = $( this ).find( "label:first-child .subs_price b" ).text();
    const updatedPrice = priceText.split( "/" )[ 0 ].trim();
    $( this ).closest( ".slide_var" ).find( ".slide_price:first" ).text( updatedPrice );
  } );

  $( ".variant-opti_sli label" ).on( "click", function () {
    const $parentContainer = $( this ).closest( ".variant-opti_sli" );
    $parentContainer.find( "label" ).removeClass( "active" );
    $( this ).addClass( "active" );
    const radioValue = $( this ).find( "input[type='radio']" ).val();
    $parentContainer.prev( "input[name='id']" ).val( radioValue );
    const priceText = $( this ).find( ".subs_price b" ).text();
    const updatedPrice = priceText.split( "/" )[ 0 ].trim();
    $( this ).closest( ".slide_var" ).find( ".slide_price:first" ).text( updatedPrice );
  } );

  // AJAX Add to Cart functionality
  $( ".add-to-cart" ).on( "click", function ( event ) {
    event.preventDefault();

    const variantId = $( this ).parent( "form" ).find( "input[name='id']" ).val();

    $.ajax( {
      type: "POST",
      url: "/cart/add.js",
      data: { id: variantId, quantity: 1 },
      dataType: "json",
      success: function ( response ) {
        console.log( "Product added:", response );
        setTimeout( () => {
          const cartDrawer = document.querySelector( "cart-drawer.drawer" );
          if ( cartDrawer ) {
            $( "div#CartDrawer" ).load( location.href + " div#CartDrawer" );
            $( ".cart-count-bubble span" ).load(
              location.href + " .cart-count-bubble span"
            );
            cartDrawer.classList.add( "active" );
            cartDrawer.classList.remove( "is-empty" );
          } else {
            console.error( "Cart drawer element not found." );
          }
        }, 500 );
      },
      error: function ( xhr, status, error ) {
        console.log( xhr.responseText );
      },
    } );
  } );

  $( document ).on( "click", ".consult", function ( e ) {
    e.preventDefault();
    $( ".consult input" ).removeClass( "check" );
    $( this ).children( "input" ).addClass( "check" );
  } );

  $( document ).on( "click", ".en_sav.sub", function ( e ) {
    e.preventDefault();
    $( ".popup_side.sub" ).addClass( "show" );
    $( "body" ).addClass( "popup" );
    $( "html" ).addClass( "popup" );
  } );
  $( document ).on( "click", ".en_sav.offer", function ( e ) {
    e.preventDefault();
    $( ".popup_side.offer" ).addClass( "show" );
    $( "body" ).addClass( "popup" );
    $( "html" ).addClass( "popup" );
  } );
  $( ".popup-close" ).on( "click", function ( e ) {
    e.preventDefault();
    $( ".popup_side.sub" ).removeClass( "show" );
    $( ".popup_side.offer" ).removeClass( "show" );
    $( "body" ).removeClass( "popup" );
    $( "html" ).removeClass( "popup" );
  } );

  $( document ).on( "click", function ( e ) {
    if (
      $( e.target ).closest( ".popup-content" ).length === 0 &&
      !$( e.target ).hasClass( "en_sav" )
    ) {
      $( ".popup_side.sub" ).removeClass( "show" );
      $( ".popup_side.offer" ).removeClass( "show" );
      $( "body" ).removeClass( "popup" );
      $( "html" ).removeClass( "popup" );
    }
  } );

  // Monitor changes to the body
  const observer = new MutationObserver( function ( mutations ) {
    mutations.forEach( function ( mutation ) {
      if ( mutation.type === "childList" ) {
        // Check if #aca-modal was added
        $( mutation.addedNodes ).each( function () {
          if ( $( this ).attr( "id" ) === "aca-modal" ) {
            // Find the .aca-product-image div
            const productImageDiv = $( ".aca-product-image" );

            if ( productImageDiv.length ) {
              // Remove the .aca-product-image div from its current position
              const productImageHTML = productImageDiv.prop( "outerHTML" );
              productImageDiv.remove();

              // Insert the .aca-product-image div before #aca-modal-container
              $( "#aca-modal-container" ).before( productImageHTML );
              console.log(
                ".aca-product-image moved before #aca-modal-container."
              );
            }
          }
        } );
      }
    } );
  } );

  // Start observing the body for changes
  observer.observe( document.body, { childList: true, subtree: true } );

  $( ".sli_pop" ).click( function () {
    $( ".popup_pro" ).fadeIn( 500 );
    $( ".product_slider" ).addClass( 'popup_open' );
    $( "html" ).addClass( 'prod_open' );
    $( "html, body" ).animate(
      {
        scrollTop: $( ".popup_pro" ).offset().top - 50, // Adjust offset if needed
      },
      800
    );
  } );

  $( ".close_pop" ).click( function () {
    $( ".popup_pro" ).fadeOut( 500 );
    $( ".product_slider" ).removeClass( 'popup_open' );
    $( "html" ).removeClass( 'prod_open' );
  } );

  // Click outside the popup to close it
  $( document ).click( function ( event ) {
    if ( !$( event.target ).closest( ".popup__content, .sli_pop" ).length ) {
      $( ".popup_pro" ).fadeOut( 500 );
      $( ".product_slider" ).removeClass( 'popup_open' );
      $( "html" ).removeClass( 'prod_open' );
    }
  } );

  const $cartDrawer = $("cart-drawer");

  const toggleBodyClass = () => {
    if ($cartDrawer.hasClass("active")) {
      $("body").addClass("drawer_car_sr");
    } else {
      $("body").removeClass("drawer_car_sr");
    }
  };

  // Monitor changes to the class attribute
  new MutationObserver(toggleBodyClass).observe($cartDrawer[0], {
    attributes: true,
    attributeFilter: ["class"]
  });

  // Initial check
  toggleBodyClass();
  
} );

$( window ).on( "load", function () {
  setTimeout( function () {
    function extractCurrencySymbol( text ) {
      return text
        .replace( /[\d\s.,]/g, "" )
        .trim()
        .charAt( 0 );
    }


    function getBasePriceData() {
      const fixedPriceText = $( ".fixed_pr" ).text().trim();

      if ( !fixedPriceText ) {
        console.error( "Base price not found. Using default value." );
        return { basePrice: 0, currencySymbol: "$" };
      }

      const basePrice = parseFloat(
        fixedPriceText.replace( /[^\d.,]/g, "" ).replace( ",", "." )
      );
      if ( isNaN( basePrice ) ) {
        console.error( "Base price is invalid:", fixedPriceText );
        return { basePrice: 0, currencySymbol: "$" };
      }

      const currencySymbol = extractCurrencySymbol( fixedPriceText );
      return { basePrice, currencySymbol };
    }
    function updatePrice( quantity ) {
      const { basePrice, currencySymbol } = getBasePriceData();

      if ( isNaN( quantity ) || quantity < 1 ) {
        console.error( "Invalid quantity:", quantity );
        return;
      }

      const newPrice = basePrice * quantity;
      let formattedPrice = newPrice.toFixed( 2 );
      const fixedPriceText = $( ".fixed_pr" ).text().trim();
      if ( fixedPriceText.indexOf( "," ) !== -1 ) {
        formattedPrice = formattedPrice.replace( ".", "," );
      }

      $( ".change_price" ).html( formattedPrice + " " + currencySymbol );


      const additionalPrice = basePrice * quantity;
      let formattedAdditionalPrice = additionalPrice.toFixed( 2 );
      if ( fixedPriceText.indexOf( "," ) !== -1 ) {
        formattedAdditionalPrice = formattedAdditionalPrice.replace( ".", "," );
      }
      $( ".change_prices" ).html( formattedAdditionalPrice + " " + currencySymbol );
    }

    $( ".quantity__button[name='minus']" ).on( "click", function () {
      const inputField = $( ".quantity__input" );
      let quantity = parseInt( inputField.val() );

      if ( !isNaN( quantity ) && quantity >= 1 ) {
        inputField.val( quantity );
        updatePrice( quantity );
      }
    } );


    $( ".quantity__button[name='plus']" ).on( "click", function () {
      const inputField = $( ".quantity__input" );
      let quantity = parseInt( inputField.val() );

      if ( isNaN( quantity ) ) {
        quantity = 1;
      }

      inputField.val( quantity );
      updatePrice( quantity );
    } );
  }, 600 );
} );
